
const moduleData = {
  id: "module-2",
  title: "Module 2",
  subtitle: "Role of Vedas/SRUTI in man's journey",
   cardImage: "/enBanner/m2_banner.jpg",
  pdfPath: "/en/Modules/m2.pdf",
  audio: {
    title: "Vedic Chanting - Placeholder",
    audioUrl: "/en/Audio/m2.mp3",
    duration: "0:00"
  },
  video: {
    id: "g-g2_g_g_g_g"
  },
  hero: {
    title: "Module 2",
    subtitle: "Role of Vedas/SRUTI in man's journey",
    description: "Content for this module is coming soon.",
    buttonText: "Explore",
    bgImage: "/enBanner/m2_banner.jpg",
    bgAlt: "Placeholder"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "Definition",
        title: "What is the Role of Vedas/SRUTI in man's journey?",
        text: "Placeholder text.",
        quote: {
          sanskrit: "",
          meaning: "",
          origin: ""
        },
        description: "Placeholder description.",
        source: "",
        image: "",
        imageAlt: ""
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
          {
            question: "What does the word “Veda” originate from?",
            options: ["The root “Vid,” meaning “to know”", "The root “Ved,” meaning “to chant”", "The root “Ved,” meaning “to write”", "The root “Vid,” meaning “to teach”"],
            answer: "The root “Vid,” meaning “to know”"
          },
          {
            question: "Who codified and presented the Vedas in three collections of hymns for humanity?",
            options: ["Sage Valmiki", "Sage Vyasa", "Sage Vishwamitra", "Sage Patanjali"],
            answer: "Sage Vyasa"
          },
          {
            question: "The Vedas are relevant only to people of the Hindu faith.",
            options: ["True", "False"],
            answer: "False"
          },
          {
            question: "Why are the Vedas known as “Shruti”?",
            options: ["Because they were written by sages", "Because they were heard and preserved orally", "Because they are sung in temples", "Because they are only for priests"],
            answer: "Because they were heard and preserved orally"
          },
          {
            question: "Which of the following is NOT one of the three main Kandas (divisions) of the Vedas?",
            options: ["Karma Kanda", "Upasana Kanda", "Jnana Kanda", "Bhakti Kanda"],
            answer: "Bhakti Kanda"
          },
          {
            question: "What is the essence of all the Vedas and Shastras?",
            options: ["The Atma that resides in all beings and in you is only one", "Rituals are the most important aspect", "Wealth is the goal of life", "Only scholars can understand the Vedas"],
            answer: "The Atma that resides in all beings and in you is only one"
          },
          {
            question: "Veda mantras must be learned under the supervision of a qualified teacher, not just from internet videos.",
            options: ["True", "False"],
            answer: "True"
          },
          {
            question: "What is the main focus of the Upanishads?",
            options: ["Rituals", "Meditation and knowledge of the Self", "Social rules", "Festivals"],
            answer: "Meditation and knowledge of the Self"
          },
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };
